import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
} from "@atlas/core";

interface CatalogPaginationProps {
  pageIndex: number;
  pageSize: number;
  totalCount: number;
  onPaginationChange: (
    updater: (prev: { pageIndex: number; pageSize: number }) => {
      pageIndex: number;
      pageSize: number;
    },
  ) => void;
}

export function CatalogPagination({
  pageIndex,
  pageSize,
  totalCount,
  onPaginationChange,
}: CatalogPaginationProps) {
  const totalPages = Math.ceil(totalCount / pageSize);

  const renderPageLinks = () => {
    const pages = [];
    const maxVisible = 5; // e.g., 1, 2, 3, 4, 5

    if (totalPages <= maxVisible) {
      for (let i = 0; i < totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (pageIndex <= 2) {
        pages.push(0, 1, 2, 3, "ellipsis", totalPages - 1);
      } else if (pageIndex >= totalPages - 3) {
        pages.push(
          0,
          "ellipsis",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
        );
      } else {
        pages.push(
          0,
          "ellipsis",
          pageIndex - 1,
          pageIndex,
          pageIndex + 1,
          "ellipsis",
          totalPages - 1,
        );
      }
    }

    return pages.map((page, idx) => {
      if (page === "ellipsis") {
        return (
          <PaginationItem key={`ellipsis-${idx}`}>
            <PaginationEllipsis />
          </PaginationItem>
        );
      }

      const pageNum = page as number;
      return (
        <PaginationItem key={pageNum}>
          <PaginationLink
            href="#"
            isActive={pageIndex === pageNum}
            onClick={(e) => {
              e.preventDefault();
              onPaginationChange((prev) => ({
                ...prev,
                pageIndex: pageNum,
              }));
            }}>
            {pageNum + 1}
          </PaginationLink>
        </PaginationItem>
      );
    });
  };

  return (
    <Pagination className="mx-0 w-auto">
      <PaginationContent>{renderPageLinks()}</PaginationContent>
    </Pagination>
  );
}
